import {
  ChannelInfo,
  UploadPlaylistCsvSettings,
  WorkingHoursSettings,
} from "../channel";
import moment from "moment";
export class Block extends ChannelInfo {
  constructor(
    id: number,
    uid: string,
    description: string,
    name: string,
    thumbnailUrl: string,
    public showsCount: number,
    public duration: moment.Duration,
    public isBlockStack: boolean,
  ) {
    super(
      id,
      uid,
      description,
      name,
      thumbnailUrl,
      false,
      null,
      null,
      22,
      null,
      "en",
      {
        fontId: 1,
        size: 25,
        subtitleStartPositionFromTop: 0,
        subtitleEndPositionFromTop: 0,
      },
      null,
      [],
      null,
      [],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      new WorkingHoursSettings(0, 0, 0, 0),
      "en",
      [],
      null,
      null,
      null,
      null,
      7, // default scheduler days to load
      true,

      isBlockStack,
      new UploadPlaylistCsvSettings([], ""),
      false,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    );
  }

  public get durationAsText(): string {
    return (
      Math.floor(this.duration.asHours()).toString().padStart(2, "0") +
      ":" +
      moment.utc(this.duration.asMilliseconds()).format("mm:ss.SSS")
    );
  }
}
